import { observable } from "mobx";
import Autobind from "autobind-decorator";
import RootStore from "./rootStore";

@Autobind
class DialogStore {
  _rootStore: RootStore; /// rootStore 객체. 다른 Store를 연계할 때 사용

  @observable
  _showAboutSoftwareDialog: boolean = false;

  @observable
  _showUserPreferencesDialog: boolean = false;

  @observable
  _showColorPickerDialog: boolean = false;

  constructor(rootStore: RootStore) {
    this._rootStore = rootStore;
  }

  getShowColorPickerDialog() {
    return this._showColorPickerDialog;
  }
  setShowColorPickerDialog(show: boolean) {
    this._showColorPickerDialog = show;
  }

  toggleShowColorPickerDialog() {
    this._showColorPickerDialog = !this._showColorPickerDialog;
  }

  getShowAboutSoftwareDialog() {
    return this._showAboutSoftwareDialog;
  }

  setShowAboutSoftwareDialog(show: boolean) {
    this._showAboutSoftwareDialog = show;
  }

  getUserPreferencesDialog() {
    return this._showUserPreferencesDialog;
  }

  setUserPreferencesDialog(show: boolean) {
    this._showUserPreferencesDialog = show;
  }
}

export default DialogStore;
